/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCardReaderChart = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3 2h18v9.674a6.952 6.952 0 0 0-2-.603V4H5v16h6.29a6.96 6.96 0 0 0 .965 2H3v-5H1V8h2zm8 10h2v2h-2zm-2 2H7v-2h2zm0 4H7v-2h2zM7 6h10v4H7zm10 9.17A3.001 3.001 0 1 0 20.83 19H17zM13 18a5 5 0 1 1 10 0 5 5 0 0 1-10 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCardReaderChart as CardReaderChart };
